module.exports = __webpack_public_path__ + "img/car-parked-moved.931c0ced.jpg";